module.exports = __webpack_public_path__ + "static/media/btn_google_light.1cdc8fce.svg";